import React from 'react';

type ContentItemProps = {
  children?: React.ReactNode;
  className?: string;
  icon?: string;
  title?: React.ReactNode;
  value?: React.ReactNode;
};

function ContentItem({
  children,
  className,
  icon,
  title,
  value,
}: ContentItemProps) {
  return value || children ? (
    <div className={className}>
      {title && <h4 className="text-grey-900 type-caption1">{title}</h4>}
      <div className="flex items-center">
        {icon && <img src={icon} className="mr-2 h-4 w-4" alt="" />}
        <span className="whitespace-pre-line">{value || children}</span>
      </div>
    </div>
  ) : null;
}

ContentItem.defaultProps = {
  className: '',
  icon: '',
  title: null,
  value: null,
};

export default ContentItem;
